export enum TipoFormatoRecebimentoDocumentoEnum {
    "Original" = "OR",
    "Cópia" = "CO"
}
